<template>
    <bar-chart ref="chartFuncionarios" :chart-data="datacollection" :options="opts" :plugin="true" v-if="datacollection"></bar-chart>
</template>


<style lang="scss">
    @import './DesempenhoHistoricoFranquia.scss';
</style>
<script>
    import Message from '@/helpers/message';
    import BarChart from '@/components/common/Charts/Bar';
    import ConverterHelper from '@/helpers/converter';
    import {
        post
    } from '@/helpers/api';
    import {
        RESPONSIVE
    } from '@/constants/chart';
    import Events from '@/helpers/events';
    import _ from 'lodash';
    import {
        ESTAGIO_PROSPECCAO,
        ESTAGIO_CHAMADA_TELEFONICA,
        ESTAGIO_PRIMEIRA_VISITA,
        ESTAGIO_EFETIVADO,
        ESTAGIO_NEGATIVADO,
        ESTAGIO_SEGUNDA_VISITA,
        ESTAGIO_EM_ESPERA,
        ESTAGIO_PERDIDO,
        ESTAGIO_NEGOCIACAO,
    } from '@/constants/pedidoEstagio.js';
    export default {
        name: "DesempenhoFuncionarios",
        components: {
            BarChart
        },
        data() {
            return {
                datacollection: null,
                opts: RESPONSIVE,
                allItens: [],
                addedItens: [],
                details: [],
            }
        },
        props: {
            filtros: {
                type: Object,
            },
            addItem: {
                type: Number,
                default: null,
            },
            removeItem: {
                type: Number,
                default: null,
            },
            id_franquia: {
                type: Number,
                default: null,
            },

        },
        created() {

            this.opts = {
                ...RESPONSIVE,
                tooltips: {
                    mode: 'index',
                    position: 'average',
                    callbacks: {
                        label: function (tooltipItem, data) {

                            let label = data.datasets[tooltipItem.datasetIndex].label || '';
                            console.log(1111111111, tooltipItem, data.datasets[tooltipItem.datasetIndex]);
                            if (label.toLowerCase() == 'total') {
                                label = (tooltipItem.yLabel + data.datasets[0].data[tooltipItem.index]) + ' ' +
                                    label;
                            } else {
                                label = tooltipItem.yLabel + ' ' + label;
                            }
                            return `${label}`;
                        },
                        footer: function (tooltipItem) {
                            return "CLIQUE PARA MAIS INFORMAÇÕES";
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                if (value % 1 === 0) {
                                    return value;
                                }
                            }
                        }
                    }]
                }
            }
            // debugger;
        },
        mounted() {
            this.$parent.$emit('showLoading', true);
            this.getData();

        },
        watch: {
            filtros: {
                deep: true,
                handler() {
                    this.getData();
                }
            },
            addItem(newValue) {
                if (newValue) {
                    this.getDataFranquia(newValue)
                }
            },
            removeItem(newValue) {
                const newData = this.addedItens.filter(item => item.funcionario.id_funcionario != newValue);
                this.addedItens = newData;
                this.preFill();
            },
        },
        methods: {
            preFill(order = false) {
                const self = this;
                let newLista = this.allItens.concat(this.addedItens);
                if (order || this.addedItens.length) {
                    newLista = newLista.sort((itemA, itemB) => {
                        if (self.filtros.order === 'desc') {
                            return itemB.leads_efetivados - itemA.leads_efetivados
                        } else {
                            return itemA.leads_efetivados - itemB.leads_efetivados
                        }
                    })
                }
                this.fill(newLista);
            },
            getDataFranquia(id) {

                if (!this.allItens.some(item => item.id == id)) {
                    this.$emit('load', true);
                    const newFiltro = this.getPreparedFilters();
                    newFiltro['id_funcionario'] = id;
                    const self = this;
                    post('grafico/relatorio-franquias-funcionarios', {
                        ...newFiltro,
                        id
                    }).then(function (response) {
                        const lista = response.data.result.data;
                        if (lista.length) {
                            self.addedItens.push(lista[0]);
                            self.preFill(true);
                        } else {
                            self.$emit('load', false);
                            Message.messageError('Franquia não possui dados');
                            self.$emit('remove', id);
                        }
                    }).catch(err => self.$emit('load', true))
                } else {
                    this.$emit('remove', id);
                }
            },

            getPreparedFilters() {

                const filtro = {
                    ...this.filtros,
                    page_qtd: 7,
                    page_ini: 1
                };

                ['data_ini', 'data_fim'].forEach(key => {

                    const date = moment(filtro[key], 'DD/MM/YYYY');

                    filtro[key] = date.isValid() ? date.format('YYYY-MM-DD') : undefined;
                })

                return filtro;
            },
            getData() {

                this.$emit('load', true);

                let self = this;

                post('grafico/relatorio-franquias-funcionarios', this.getPreparedFilters()).then(function (response) {
                    const lista = response.data.result.data;
                    self.allItens = lista;
                    if (!self.allItens.length) {
                        self.$emit('load', true)
                    }
                    self.preFill();
                    self.opts['onClick'] = function (evt, item) {
                        const activePoints = this.getElementsAtEvent(evt);
                        if (activePoints[0]) {
                            const data = activePoints[0]._chart.data;
                            const datasetIndex = activePoints[0]._datasetIndex;
                            // const estagio = activePoints[0]._chart.data.datasets[activePoints[0]._index].label;

                            const id_funcionario = activePoints[0]._chart.data.datasets[0].id_funcionario[
                                activePoints[0]._index];
                            const quantidade = data.datasets[datasetIndex].data[activePoints[0]._index];
                            const chartData = activePoints[0]['_chart'].config.data;
                            const franquia = chartData.labels[activePoints[0]._index];
                            self.$emit('clickFuncionario', id_funcionario);
                        }
                    };
                }).catch(err => self.$emit('load', true))
            },
            fill(lista) {

                let graficoInformacoes = {
                    labels: [],
                    datasets: [{
                            backgroundColor: [],
                            data: [],
                            extra: [],
                            id_funcionario: null,
                            label: 'Efetivados',
                        },
                        {
                            backgroundColor: [],
                            data: [],
                            extra: [],
                            label: 'Total',
                        }
                    ]
                };

                const estagiosPadroes = {
                    ESTAGIO_EFETIVADO: 0,
                };

                let estagioIdsVisitados = [];
                let adicionadosLabels = [];
                graficoInformacoes.datasets[0].id_funcionario = [];
                graficoInformacoes.datasets[1].id_funcionario = [];

                lista.forEach(item => {

                    const novoEstagiosPadroes = {
                        ...estagiosPadroes
                    };
                    graficoInformacoes.labels.push(ConverterHelper.formatLabelChart(item.funcionario
                        .nome_funcionario, 20));

                    graficoInformacoes.datasets[0].backgroundColor.push(ConverterHelper.getCorEstagio(
                        ESTAGIO_EFETIVADO));
                    graficoInformacoes.datasets[0].data.push(item.leads.efetivado);
                    graficoInformacoes.datasets[0].extra.push(`${item.leads.porcent}% efetivados`);
                    graficoInformacoes.datasets[0].id_funcionario.push(item.funcionario.id_funcionario);
                    graficoInformacoes.datasets[1].id_funcionario.push(item.funcionario.id_funcionario);
                    graficoInformacoes.datasets[1].efetivados = item.leads.efetivado;
                    graficoInformacoes.datasets[1].backgroundColor.push('rgb(228, 228, 228, .8)');
                    graficoInformacoes.datasets[1].data.push(item.leads.total - item.leads.efetivado);
                    graficoInformacoes.datasets[1].extra.push(`${item.leads.porcent}% efetivados`);
                })


                this.$emit('load', false);

                this.datacollection = graficoInformacoes;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/charts/DesempenhoFuncionarios.vue